const en = {
    checkout: {
        not_available: '<span>No Checkout</span> Available',
        loading: ''
    },
    payment: {
        loading: 'LOADING PAYMENT DATA',
        another_method: 'Choose another payment method',
        received: 'Your payment has already been received.',
        review: 'Review Your Order',
        total: 'Total',
        choose_method: 'Choose Your Payment Method',
        description: '*Following payment, you will be asked to enter your name and date of birth in order for us to generate your personalized IQ certificate. Price incl. VAT.',
        incl_vat: '*Price incl. VAT.',
        terms: 'Terms',
        apply: 'apply',
        result: {
            success: 'Received payment!',
            error: 'Payment failed! Choose another method and try again.',
        }
    },
    common: {
        continue: 'Continue',
        loading: 'INITIALIZING',
        thanks: 'Thank you!'
    },
    error: {
        click_here: 'Click here ',
        to_homepage: 'to return to our main page'
    },
    info: {
        registry: 'Commercial Registry',
    },
    nav: {
        home: 'Home',
        jobs: 'Jobs',
        about_us: 'About Us',
        terms: 'Terms',
        gdpr: 'Data Protection',
        imprint: 'Imprint',
        disclaimer: 'Disclaimer: We are devoted to the development of high-quality intelligence assessment tools and entertainment products. Please do not use our content to make important life decisions or for the purpose of seeking any medical advice.'
    }
};

export default en;
